import React, { useEffect, useState, createRef } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { categoriaProdutoAction } from '../../_actions'
import PropTypes from 'prop-types'
import {
  withStyles,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Grid,
  IconButton,
  Input,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip
} from '@material-ui/core'
import {
  ValidatorForm,
  TextValidator
} from 'react-material-ui-form-validator'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import { withRouter } from 'react-router-dom'
import { stringUtils } from '../../utils'
import TitleContent from '../TitleContent'
import { useConfirm } from 'material-ui-confirm'
import { AccessControl } from '../../components/Utils/AccessControl'
import AccessDenied from '../Errors/AccessDenied'
import { Page, PaginationActions } from 'components'
import { useDebounce } from 'use-debounce'

const styles = (theme) => ({
  root: {
    padding: theme.spacing(3, 2, 2, 2)
  },
})

const CategoriaProduto = (props) => {
  const confirm = useConfirm()
  const dispatch = useDispatch()
  const formRef = createRef(null);
  const { classes } = props
  const { match: { params } } = props;
  const { categoriaProduto, totalRegistros } = props.categoriaProduto
  const { page, limit, term, direction, order } = useSelector(state => state.categoriaProduto);
  const [debounceTerm] = useDebounce(term, 1000)

  const [open, setOpen] = useState(false);

  const [categoriaProdutoId, setCategoriaProdutoId] = useState(0);
  const [categoriaProdutoNome, setCategoriaProdutoNome] = useState('');

  const [selectedCategoria, setSelectedCategoria] = useState(null);

  useEffect(() => {
    fetchData();
  }, [page, limit, debounceTerm]);

  useEffect(() => {
    handleChangePage(null, 0);
  }, [totalRegistros])

  const fetchData = () => {
    let filterModel = {
      Page: page || 0,
      Limit: limit || 10,
      Term: debounceTerm || '',
      Order: order || 'nome',
      Direction: direction || 'asc',
    };

    dispatch(categoriaProdutoAction.getCategoria(filterModel, true));
  };

  const handleChange = prop => event => {
    dispatch(categoriaProdutoAction.onChangeProps(prop, event))
  };

  const handleChangePage = (_, value) => {
    const fakeEvent = {
      type: 'text',
      target: {
        value
      }
    }
    dispatch(categoriaProdutoAction.onChangeProps('page', fakeEvent))
  }

  const handleChangeTerm = (value) => {
    const fakeEvent = {
      type: 'text',
      target: {
        value
      }
    }
    props.categoriaProduto.page = 0;
    dispatch(categoriaProdutoAction.onChangeProps('term', fakeEvent))
  }

  const handleEdit = (event, categoriaProduto) => {
    setCategoriaProdutoId(categoriaProduto.id)
    setCategoriaProdutoNome(categoriaProduto.nome)

    handleClickOpen(event)
  };

  const handleDelete = (id) => {
    confirm({
      title: 'Você deseja excluir esta Categoria?',
      description: 'Essa operação é irreversível',
      confirmationText: 'Sim, excluir!',
      disabled: props.categoriaProduto.isLoading,
      confirmationText: props.categoriaProduto.isLoading ? 'Excluindo categoria...' : 'Sim, excluir!',
      cancellationText: 'Não!'
    }).then(() => {
      dispatch(categoriaProdutoAction.deleteCategoriaById(id))

      setCategoriaProdutoId(0);
      setCategoriaProdutoNome('');
    })
  }

  const handleClickOpen = (event) => {
    event.preventDefault();
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);

    setCategoriaProdutoId(0);
    setCategoriaProdutoNome('');
  };

  const handleChangeCategoriaProdutoNome = (event) => {
    setCategoriaProdutoNome(event.target.value)
  }

  const handleSubmit = (event) => {
    let payload = {
      id: categoriaProdutoId,
      nome: categoriaProdutoNome,
    }

    if (categoriaProdutoId) {
      dispatch(categoriaProdutoAction.editCategoriaInfo(categoriaProdutoId, payload, true));
    } else {
      dispatch(categoriaProdutoAction.createCategoria(payload));
    }

    handleClose();
  };

  return (
    <Page
      className={classes.root}
      title={
        params.id
          ? 'Gerência de Categorias - Editar Categoria'
          : 'Gerência de Categorias - Nova Categoria'
      }
    >
      <AccessControl
        rule={'categoriasCompras'}
        yes={() => (
          <div>
            <TitleContent
              rule={'categoriasCompras.create'}
              length={undefined !== categoriaProduto && categoriaProduto.length > 0 ? categoriaProduto.length : 0}
              subTitle={'GERÊNCIA DE CATEGORIA'}
              title={'Lista de Categorias de Produtos'}
              handleOpen={(e) => handleClickOpen(e)}
            />
            <Grid container spacing={3}>
              <Grid item xl={4} lg={4} md={6} xs={12}>
                <Input
                  id="term"
                  label="term"
                  placeholder="Filtro"
                  value={term}
                  onChange={(event) => handleChangeTerm(event.target.value)}
                  fullWidth
                />
              </Grid>
            </Grid>
            <br />
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Nome</TableCell>
                    <TableCell align="right">Ações</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {undefined !== categoriaProduto && categoriaProduto.length
                    ? categoriaProduto.map((c) => {
                      return (
                        <TableRow hover key={c.id}>
                          <TableCell component="th" scope="row">
                            {c.nome}
                          </TableCell>
                          <TableCell align="right">
                            <AccessControl
                              rule={'categoriasProdutos.edit'} //permissão necessária para acessar conteúdo
                              yes={() => (
                                <IconButton
                                  aria-label="Edit"
                                  component="a"
                                  onClick={(event) => handleEdit(event, c)}
                                  size="small"
                                >
                                  <Tooltip title={'Editar'}>
                                    <Tooltip>
                                      <EditIcon />
                                    </Tooltip>
                                  </Tooltip>
                                </IconButton>
                              )}
                            />
                            <AccessControl
                              rule={'categoriasProdutos.delete'} //permissão necessária para acessar conteúdo
                              yes={() => (
                                <IconButton
                                  aria-label="Delete"
                                  onClick={() => handleDelete(c.id)}
                                  size="small"
                                >
                                  <Tooltip title="Excluir">
                                    <DeleteIcon />
                                  </Tooltip>
                                </IconButton>
                              )}
                            />
                          </TableCell>
                        </TableRow>
                      )
                    })
                    : null}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              count={totalRegistros}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={limit}
              onRowsPerPageChange={handleChange('limit')}
              ActionsComponent={PaginationActions}
            />

            <Dialog open={open} onClose={handleClose} fullWidth>
              <ValidatorForm
                className={classes.form}
                ref={formRef}
                id="formCategoriaProduto"
                onSubmit={(event) => handleSubmit(event)}
              >
                <DialogContent>
                  <DialogContentText>
                    {(categoriaProdutoId ? 'Editar' : 'Adicionar') + ' Categoria'}
                  </DialogContentText>

                  <TextValidator
                    InputLabelProps={{ shrink: true }}
                    className={classes.textField}
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    label="Nome *"
                    value={categoriaProdutoNome}
                    onInput={stringUtils.toInputUppercase}
                    onChange={handleChangeCategoriaProdutoNome}
                    id="nome"
                    validators={['required']}
                    errorMessages={['Campo obrigatório!']}
                  />
                </DialogContent>
                <DialogActions>
                  <Button
                    color="default"
                    onClick={handleClose}
                    variant="contained"
                  >
                    Cancelar
                  </Button>
                  <Button
                    color="primary"
                    onClick={handleSubmit}
                    variant="contained"
                  >
                    {categoriaProdutoId ? 'Editar' : 'Adicionar'}
                  </Button>
                </DialogActions>
              </ValidatorForm>
            </Dialog>
          </div>
        )}
        no={() => <AccessDenied />}
      />
    </Page>
  )  
}

CategoriaProduto.propTypes = {
  classes: PropTypes.object.isRequired
}
const mapStateToProps = (state) => {
  return {
    categoriaProduto: state.categoriaProduto
  }
}
const connectedCategoriaProdutoPage = withRouter(
  connect(mapStateToProps, null, null, {
    pure: false
  })(withStyles(styles)(CategoriaProduto))
)
export { connectedCategoriaProdutoPage as CategoriaProduto }
